import { Edit, Settings } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import SortIcon from "@mui/icons-material/Sort";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FundingNewVehicleColumnData } from "../../common/constants/gridRowColumn";
import {
  useAnalysis,
  useCompany,
  useDealer,
  useFleetList,
  useFuelAnalysis,
  useFuelList,
  useFundList,
  useMaintainance,
  useMake,
  useModel,
  useMovableColumn,
  useNewVehicle,
  usePagination,
  useReplacement,
  useSortableColumn,
  useUser,
  useYear,
} from "../../common/hooks";
import { SearchBar } from "../../components/SearchBar";
import { layoutStyle } from "../layout-ui/style";
import { DeleteDialog } from "../../components/DeleteDialog";
import moment from "moment";
import { TruckLoader } from "./truckLoader";
import { useDebounce } from "../../components/useDebounce";
import AddActionDialogNewVehicle from "../../components/AddActionDialogNewVehicle";
import { removeCurrency, removeCommaAndRemoveCurrency } from "../../common/services/number-service";
import { sumFuelCosts } from "../../common/utils/methods";
import { showErrorToast, showToast } from "../../components/Toast";
import {
  actionColumnFunction,
  checkFieldColumn,
  checkbox,
  ensureHeaderTooltip,
  getDefaultColDef,
  setModalContentByAction,
  sidebarMenu,
} from "../../common/constants/commonFunction";
import { getCompanyId } from "../../common/constants/commonFunction";
import useFleetStatistics from "../../common/constants/Report-Calculation/fleetStats";
import useMaintenanceStatistics from "../../common/constants/Report-Calculation/maintenanceStats";
import useFuelStatistics from "../../common/constants/Report-Calculation/fuelStats";
import useNewVehicleStatistics from "../../common/constants/Report-Calculation/newVehicleStats";
import useFleetManagement from "../../common/constants/Report-Calculation/fleetManagement";
import { TAB_CONTENT, TAB_VALUE } from "../../common/constants/popupMessage";
import { ReplaceExistingVehicle } from "../../components/Funding-New-Vehicle/ReplaceExistingVehicle";
import {
  getNullVehicleFields,
  uniqueNullValues,
  uniqueVehicleNullValues,
} from "../../common/constants/findNullValueGrid";
import { toast } from "react-toastify";
import { PageNameConstant } from "../../common/constants/PageNameConstant";
import { localStorageItemNames } from "../../common/constants";
import { PopupBlock } from "../../components/PopupBlock";
import {
  applyActiveSortToColumns,
  getActiveSortRequest,
  getActiveSortRecord,
  onSortChanged,
  sortRowsByActiveSort,
  updateGridSortState,
} from "../../common/utils/sortingColumn";
import { columnSortingMessage } from "../../common/utils/columnSortingMessage";
import { SortingTextPopup } from "../../components/SortingTextPopup";
import { DEALEAR_DEFAULT } from "../../common/constants/dealer-name";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box component="div">{children}</Box>
        </Box>
      )}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const FundingNewVehicle = () => {
  const classes = layoutStyle();

  const [columnFinal, setColumnFinal] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowDataFinal, setRowDataFinal] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [replaceVehicleOpen, setReplaceVehicleOpen] = useState(false);
  const [deleteValue, setDeleteValue] = useState();
  const { state } = useLocation();
  const navigation = useNavigate();
  //Generate Report
  const { getFleetListApi, fleetList, requireFields, setRequireFields } =
    useFleetList();
  const { getMaintananceApi, maintanance, setMaintanance } = useMaintainance();
  const { fuelListFilter, getFuelAnalysisApiList, setFuelListFilter } =
    useFuelAnalysis();
  const { getReplacementListApi, replacementList, setReplacementList } =
    useReplacement();
  const [purchaseFinance, setPurchaseFinance] = useState(0);
  const [rowIndex, setRowIndex] = useState(0);
  const [cashOutlay, setCashOutlay] = useState(0);
  const [averageCostPerMilesMaintanance, setAverageCostPerMilesMaintanance] =
    useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [keyValue, setKeyValue] = useState("");
  const [dropdownValue, setDropDownValue] = useState([]);
  const [modalContent, setModalContent] = useState("");
  const {
    setSelectedNav,
    columnChange,
    setColumnChange,
    popupBlock,
    setPopupBlock,
    setSidebarColumnPopup,
    setSelectedItemIndex,
  } = useUser();
  //Generate Report End
  const { addAnalysisResultApi } = useAnalysis();
  const {
    getNewVehicleApi,
    newVehicle,
    deleteNewVehicleByIdApi,
    loading,
    setNewVehicle,
    requireNewvehicleFields,
    setRequireNewVehicleFields,
    setToastClose,
    toastClose,
    multipleApi,
  } = useNewVehicle();
  const { deletFleetListByIdApi } = useFleetList();
  const { companyNameHeader, dealerNameHeader } = useCompany();
  const { fuelList, getFuelListApi } = useFuelList();
  const { getFundListApi, fundList } = useFundList();
  const { make, getMakeApi } = useMake();
  const { year, getYearApi } = useYear();
  const { modelData, getModelList, setModelData } = useModel();
  const [anchorElSearch, setAnchorElSearch] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const userType = localStorage.getItem("type");
  const localUserId = localStorage.getItem(localStorageItemNames.userID);
  const companyId = getCompanyId(userType, companyNameHeader);
  const {
    setNewFleetNo,
    autoMultipleManualCalculationApi,
    autoCalculation,
    setAutoCalculation,
  } = useDealer();
  const [loadingApis, setLoadingApis] = useState(false);
  const gridRef = useRef(null);
  const [movableColumnData, setMovableColumnData] = useState([]);
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
    sortedColumn,
    setSortedColumn,
  } = useMovableColumn();
  const {
    getSortableColumnApi,
    sortableColumnData,
    createSortableColumn,
    updateViewSortableColumn,
  } = useSortableColumn();
  const [nextButton, setNextButton] = useState("");
  const [prevButton, setPrevButton] = useState("");
  const [openSortingPopup, setOpenSortingPopup] = useState(false);
  const {
    fundingPagination,
    setPagination,
    setFleetPagination,
    setMaintainancePagination,
    setFuelPagination,
    setFundingPagination,
  } = usePagination();

  const onSearch = (e) => {
    debouncedSearch(e?.target?.value);
    handleClickSearch(e);
  };
  const handleClickSearch = (event) => {
    setAnchorElSearch(event.currentTarget);
  };
  const onSearchFunc = (e) => {
    setSearchValue(e[0]);
  };
  const debouncedSearch = useDebounce(onSearchFunc, 500);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOnClose = () => {
    setAnchorEl(null);
  };
  const closeModal = () => {
    // setIsModalOpen(false);
    setModalContent("");
    document.activeElement?.blur();
  };
  const handleActionSelect = (action, value, key) => {
    handleOnClose();
    setDropDownValue(value);
    setKeyValue(key);
    setModalContentByAction({
      action: action,
      setModalContent: setModalContent,
      setReplaceVehicleOpen: setReplaceVehicleOpen,
    });
  };
  useEffect(() => {
    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fundingNewVehicle,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fundingNewVehicle,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    setReplacementList([]);
    setColumnChange(false);
    setSidebarColumnPopup("");
    setNewVehicle([]);
    setNewFleetNo(null);
    setMaintanance([]);
    setFuelListFilter([]);
    setModelData([]);
    getFundListApi();
    getMakeApi();
    getYearApi();
    getFuelListApi();
    setPagination(0);
    setFleetPagination(0);
    setMaintainancePagination(0);
    setFuelPagination(0);
  }, []);

  useEffect(() => {
    if (fuelListFilter?.length > 0) {
      setAutoCalculation(false);
    }
  }, [fuelListFilter]);
  const defaultColDef = useMemo(
    () => ({ ...getDefaultColDef(), sortable: true }),
    []
  );

  const handleDelete = async () => {
    const payload = {
      id: deleteValue?.id ?? deleteValue,
      companyId,
      dealerId: dealerNameHeader?.id ?? DEALEAR_DEFAULT.dealerId,
      userId: localUserId,
    };
    await deleteNewVehicleByIdApi(payload);

    if (deleteValue?.fleetId) {
      await deletFleetListByIdApi({
        id: deleteValue.fleetId,
        companyId,
        dealerId: dealerNameHeader?.id ?? DEALEAR_DEFAULT.dealerId,
        userId: localUserId,
      });
    }
    setDeleteOpen(false);
    setDeleteValue(null);
  };

  const onCellClicked = (event) => {
    let checkField = checkFieldColumn(event);
    if (checkField) {
      handleEditButton(event?.data);
    }
  };
  useEffect(() => {
    if (companyNameHeader?.id) {
      if (newVehicle?.length > 0 && autoCalculation) {
        getSortableColumnApi({
          filter: {
            userId: localStorage.getItem(localStorageItemNames.userID),
            pageName: PageNameConstant.fundingNewVehicle,
            companyId: localStorage.getItem(localStorageItemNames.companyId),
            dealerId: DEALEAR_DEFAULT.dealerId,
          },
        });
        getMovableColumnApi({
          filter: {
            userId: localStorage.getItem(localStorageItemNames.userID),
            pageName: PageNameConstant.fundingNewVehicle,
            companyId: localStorage.getItem(localStorageItemNames.companyId),
            dealerId: DEALEAR_DEFAULT.dealerId,
          },
        });
        getFuelAnalysisApiList({
          fleetNo: "",
          companyId: companyNameHeader?.id,
          dealerId: dealerNameHeader?.id ?? DEALEAR_DEFAULT.dealerId,
          userId: localUserId,
        });
      }
    }
  }, [autoCalculation, newVehicle, companyNameHeader?.id]);

  useEffect(() => {
    const fetchFields = async () => {
      try {
        setLoadingApis(true);
        const activeDealerId = dealerNameHeader?.id ?? DEALEAR_DEFAULT.dealerId;
        await Promise.all([
          getFleetListApi({
            companyId: companyId,
            dealerId: DEALEAR_DEFAULT.dealerId,
            userId: localUserId
          }),
          getMaintananceApi({
            companyId: companyId,
            dealerId: DEALEAR_DEFAULT.dealerId,
            userId: localUserId
          }),
          getReplacementListApi({
            companyId: companyId,
            dealerId: DEALEAR_DEFAULT.dealerId,
            userId: localUserId
          }),
          getFuelAnalysisApiList({
            fleetNo: "",
            companyId: companyId,
            dealerId: activeDealerId,
            userId: localUserId
          }),
        ]);
      } finally {
        setLoadingApis(false);
      }
    };

    if (newVehicle?.length > 0 && !multipleApi && !loading && companyId) {
      fetchFields();
    }
  }, [newVehicle]);

  useEffect(() => {
    if (companyId) {
      const loadNewVehicles = async () => {
        const sortResponse = await getSortableColumnApi({
          filter: {
            userId: localStorage.getItem(localStorageItemNames.userID),
            pageName: PageNameConstant.fundingNewVehicle,
            companyId: localStorage.getItem(localStorageItemNames.companyId),
            dealerId: DEALEAR_DEFAULT.dealerId,
          },
        });
        getNewVehicleApi({
          fleetNo: "",
          companyId: companyId,
          dealerId: DEALEAR_DEFAULT.dealerId,
          userId: localUserId,
          ...getActiveSortRequest(sortResponse),
        });
      };
      loadNewVehicles();
    } else {
      setNewVehicle([]);
    }
  }, [companyId]);
  //Generate Report Start

  const {
    currentFleetSize,
    oldVehicleYear,
    avgYear,
    currentTotalMileage,
    fuelAverageMileageCache,
  } = useFleetStatistics(fleetList);

  const {
    currentTotalAnnualizedSpend,
    currentYearTotalCost,
    maintenanceYear,
    maintenanceVehicleSpend,
    maintenanceVehicleSpendMonthly,
    averageCostPerMilesMaintenance,
    avgCostPerMiles,
    oneYearTotalCostValue,
    oneYearMaintenanceCost,
    oneYearMaintenanceTotalMiles,
  } = useMaintenanceStatistics(maintanance);

  const {
    anticipatedMpgValue,
    totalFuelSpend,
    annualSpendVehicle,
    monthlySpendVehicle,
    foreCastedValue,
    currentFuelSize,
    averageFuelGallon,
    cycleFuelYearCost,
    cycleFuelYearCost2,
    cycleFuelYearCost3,
    cycleFuelYearCost4,
    cycleFuelYearCost5,
    fuelAverageMileage,
  } = useFuelStatistics(fuelListFilter, fuelAverageMileageCache);

  const {
    averageNewVehicleCost,
    paymentFundingAmount,
    monthlyLeaseCost,
    monthlyPaymentAmount,
  } = useNewVehicleStatistics(newVehicle, fleetList);

  const { rowData, proposedCycleYear, savingTotal } = useFleetManagement(
    currentFleetSize,
    replacementList,
    rowIndex,
    monthlyPaymentAmount,
    purchaseFinance,
    cashOutlay,
    newVehicle,
    maintanance,
    fuelListFilter,
    totalFuelSpend,
    fleetList,
    companyNameHeader,
    cycleFuelYearCost,
    cycleFuelYearCost2,
    cycleFuelYearCost3,
    cycleFuelYearCost4,
    cycleFuelYearCost5
  );

  //Generate Report End
  useEffect(() => {
    let enrichedNewVehicle = newVehicle;
    if (newVehicle?.length > 0 && fleetList?.length > 0) {
      enrichedNewVehicle = newVehicle.map(nv => {
        const matchingFleet = fleetList.find(f => f.fleetNo === nv.fleetNo);
        return {
          ...nv,
          annualMileage: nv.annualMileage || (matchingFleet ? matchingFleet.annualMileage : undefined)
        };
      });
    }

    const filteredRows = searchValue
      ? enrichedNewVehicle.filter((row) =>
          row?.fleetNo?.toLowerCase().includes(searchValue.toLowerCase())
        )
      : enrichedNewVehicle;
    if (filteredRows?.length > 0) {
      setRowDataFinal(
        sortRowsByActiveSort(
          filteredRows,
          getActiveSortRecord(sortableColumnData)
        )
      );
    } else {
      setRowDataFinal([]);
    }
  }, [newVehicle, fleetList, searchValue, sortableColumnData]);

  useEffect(() => {
    if (state?.data) {
      setRowDataFinal(
        sortRowsByActiveSort(
          state.data,
          getActiveSortRecord(sortableColumnData)
        )
      );
    } else {
      setRowDataFinal(
        sortRowsByActiveSort(
          newVehicle,
          getActiveSortRecord(sortableColumnData)
        )
      );
    }
  }, [state?.data, newVehicle, sortableColumnData]);

  useEffect(() => {
    if (movableColumnData && !loading && newVehicle?.length > 0) {
      const values = uniqueVehicleNullValues(newVehicle);
      if (values?.length > 0 && companyNameHeader !== null && toastClose) {
        setRequireNewVehicleFields(values);
      } else {
        setRequireNewVehicleFields([]);
      }
    } else {
      setRequireNewVehicleFields([]);
    }
    setColumnFinal([...movableColumnData]);
  }, [movableColumnData, loading, toastClose]);

  useEffect(() => {
    const activeSort = getActiveSortRecord(sortableColumnData);
    if (activeSort && movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = applyActiveSortToColumns(
        JSON.parse(dataMovable?.columnName),
        activeSort
      );
      columnParse?.map((items) => {
        const defaultMatch = FundingNewVehicleColumnData.find(c => c.field === items.field);
        if (defaultMatch) {
          items.minWidth = defaultMatch.minWidth;
          items.headerName = defaultMatch.headerName;
        }
      });
      // Check if originalModel is missing in saved layout
      if (!columnParse.some(c => c.field === "originalModel")) {
        const makeIndex = columnParse.findIndex(c => c.field === "make");
        const origModelCol = FundingNewVehicleColumnData.find(c => c.field === "originalModel");
        if (origModelCol) {
          columnParse.splice(makeIndex !== -1 ? makeIndex + 1 : 2, 0, origModelCol);
        }
      }
      // Check if annualMileage is missing in saved layout
      if (!columnParse.some(c => c.field === "annualMileage")) {
        const fleetIndex = columnParse.findIndex(c => c.field === "fleetNo");
        const annualMileageCol = FundingNewVehicleColumnData.find(c => c.field === "annualMileage");
        if (annualMileageCol) {
          columnParse.splice(fleetIndex !== -1 ? fleetIndex + 1 : 1, 0, annualMileageCol);
        }
      }
      setMovableColumnData(columnParse);
    } else if (movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = applyActiveSortToColumns(
        JSON.parse(dataMovable?.columnName),
        activeSort
      );
      columnParse?.map((items) => {
        const defaultMatch = FundingNewVehicleColumnData.find(c => c.field === items.field);
        if (defaultMatch) {
          items.minWidth = defaultMatch.minWidth;
          items.headerName = defaultMatch.headerName;
        }
      });
      // Check if originalModel is missing in saved layout
      if (!columnParse.some(c => c.field === "originalModel")) {
        const makeIndex = columnParse.findIndex(c => c.field === "make");
        const origModelCol = FundingNewVehicleColumnData.find(c => c.field === "originalModel");
        if (origModelCol) {
          columnParse.splice(makeIndex !== -1 ? makeIndex + 1 : 2, 0, origModelCol);
        }
      }
      // Check if annualMileage is missing in saved layout
      if (!columnParse.some(c => c.field === "annualMileage")) {
        const fleetIndex = columnParse.findIndex(c => c.field === "fleetNo");
        const annualMileageCol = FundingNewVehicleColumnData.find(c => c.field === "annualMileage");
        if (annualMileageCol) {
          columnParse.splice(fleetIndex !== -1 ? fleetIndex + 1 : 1, 0, annualMileageCol);
        }
      }
      setMovableColumnData(columnParse);
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: true,
      });
      setMovableColumnData([
        checkbox,
        ...applyActiveSortToColumns(FundingNewVehicleColumnData, activeSort),
        actionColumn,
      ]);
    }
  }, [FundingNewVehicleColumnData, movableColumn, sortableColumnData]);

  const handleUpdateCalculation = async (event) => {
    const data = [];
    replacementList?.map((items) => {
      let payload = {
        companyId: companyNameHeader?.id,
        dealerId: dealerNameHeader?.id,
        company: items.companyName,
        dealer: items.dealerName,
        vin: items.vin,
        stateCode: items.stateCode,
        stateName: items.state,
        make: items.make,
        model: items.model,
        fuelId: items.fuelId,
        typeId: items.typeId,
        fleetNo: items.fleetNo,
        mpg: Number(items.mpg),
        year: items.year,
        cyclingFuelEco: items.cyclingFuelEco,
        totalMiles: items.totalMiles,
        replacementSchedule: {
          fleetNo: items.fleetNo,
          id: items.replacementId,
          year1: items.year1,
          year2: items.year2,
          year3: items.year3,
          year4: items.year4,
          year5: items.year5,
        },
      };
      data.push(payload);
    });
    await autoMultipleManualCalculationApi(data);
  };

  useEffect(() => {
    if (replacementList?.length > 0) {
      handleUpdateCalculation();
    }
  }, [replacementList]);

  useEffect(() => {
    if (
      requireNewvehicleFields &&
      !loading &&
      newVehicle?.length > 0 &&
      toastClose
    ) {
      const values = uniqueVehicleNullValues(newVehicle);
      const arrayJson = getNullVehicleFields(values);
      const requireField = getNullVehicleFields(requireFields);
      if (arrayJson?.length > 0 || requireField?.length > 0) {
        showErrorToast(
          <>
            {arrayJson && (
              <>
                <div style={{ fontWeight: 600, marginBottom: 5 }}>
                  NewVehicle: Require fields
                </div>
                <div style={{ marginBottom: 10 }}>{arrayJson}</div>
              </>
            )}
            {requireField && requireField?.length > 0 && (
              <>
                <div style={{ fontWeight: 600, marginBottom: 5 }}>
                  Current Fleet Details: Require fields
                </div>
                <div>{requireField}</div>
              </>
            )}
          </>,
          companyNameHeader == null ? true : false
        );
      } else {
        toast.dismiss();
      }
    } else {
      toast.dismiss();
    }
    return () => { };
  }, [requireNewvehicleFields]);

  const handleAddButton = () => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
      },
    });
  };
  const handleEditButton = (params) => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FUNDING_NEW_VEHICLE,
        selectedContent: TAB_CONTENT.FUNDING_NEW_VEHICLE,
        data: params,
      },
    });
  };
  const handleDeleteButton = async (values) => {
    setDeleteOpen(true);
    setDeleteValue({
      id: values?.id ?? values?.newVehicleId ?? values?.vehicleId ?? values,
      fleetId: values?.fleetId,
      companyId,
      dealerId: dealerNameHeader?.id ?? DEALEAR_DEFAULT.dealerId,
      userId: localUserId,
    });
  };
  const handleNext = async (event) => {
    const activeDealerId = dealerNameHeader?.id ?? DEALEAR_DEFAULT.dealerId;
    let fuelResponse = await getFuelAnalysisApiList({
      fleetNo: "",
      companyId: companyId,
      dealerId: activeDealerId,
      userId: localUserId,
    });
    let latestFuelRows = Array.isArray(fuelResponse?.data)
      ? fuelResponse.data
      : Array.isArray(fuelResponse?.data?.data)
        ? fuelResponse.data.data
        : Array.isArray(fuelResponse)
          ? fuelResponse
          : [];

    if (!latestFuelRows.length && activeDealerId !== DEALEAR_DEFAULT.dealerId) {
      const fallbackResponse = await getFuelAnalysisApiList({
        fleetNo: "",
        companyId: companyId,
        dealerId: DEALEAR_DEFAULT.dealerId,
        userId: localUserId,
      });
      latestFuelRows = Array.isArray(fallbackResponse?.data)
        ? fallbackResponse.data
        : Array.isArray(fallbackResponse?.data?.data)
          ? fallbackResponse.data.data
          : Array.isArray(fallbackResponse)
            ? fallbackResponse
            : [];
    }

    if (!latestFuelRows.length && fuelListFilter?.length) {
      latestFuelRows = fuelListFilter;
    }

    // Ensure we have fuel data - if not, log warning
    if (!latestFuelRows || latestFuelRows.length === 0) {
      console.warn("No fuel analysis data found. Using cached fuel statistics.");
    }

    let computedFuelSize = latestFuelRows.length || currentFleetSize || 1;
    let sumOrigMpg = 0;
    let sumCyclingMpg = 0;
    let sumAvgGallon = 0;
    let sumForecasted = 0;
    let sumAnnualCurrent = 0;
    let sumCycleYear1 = 0;
    let sumCycleYear2 = 0;
    let sumCycleYear3 = 0;
    let sumCycleYear4 = 0;
    let sumCycleYear5 = 0;

    latestFuelRows.forEach((item) => {
      sumOrigMpg += Number(item["originalFuelEconomy"] || item["OriginalFuelEconomy"] || 0);
      sumCyclingMpg += Number(item["cyclingFuelEconomy"] || item["CyclingFuelEconomy"] || item["originalFuelEconomy"] || 0);
      sumAvgGallon += removeCommaAndRemoveCurrency(item["averageFuelPrice"] || item["AverageFuelPrice"]);
      sumForecasted += removeCommaAndRemoveCurrency(item["annualFuelSpendForecasted"] || item["AnnualFuelSpendForecasted"]);

      const currentCost =
        removeCommaAndRemoveCurrency(item["annualFuelCostCurrent"] || item["AnnualFuelCostCurrent"]) ||
        removeCommaAndRemoveCurrency(item["anticipatedFuelCostCurrent"] || item["AnticipatedFuelCostCurrent"]);
      sumAnnualCurrent += currentCost;

      const y1 =
        removeCommaAndRemoveCurrency(item["annualFuelCostYear1"] || item["AnnualFuelCostYear1"]) ||
        removeCommaAndRemoveCurrency(item["anticipatedFuelCostYear1"] || item["AnticipatedFuelCostYear1"]);
      const y2 =
        removeCommaAndRemoveCurrency(item["annualFuelCostYear2"] || item["AnnualFuelCostYear2"]) ||
        removeCommaAndRemoveCurrency(item["anticipatedFuelCostYear2"] || item["AnticipatedFuelCostYear2"]);
      const y3 =
        removeCommaAndRemoveCurrency(item["annualFuelCostYear3"] || item["AnnualFuelCostYear3"]) ||
        removeCommaAndRemoveCurrency(item["anticipatedFuelCostYear3"] || item["AnticipatedFuelCostYear3"]);
      const y4 =
        removeCommaAndRemoveCurrency(item["annualFuelCostYear4"] || item["AnnualFuelCostYear4"]) ||
        removeCommaAndRemoveCurrency(item["anticipatedFuelCostYear4"] || item["AnticipatedFuelCostYear4"]);
      const y5 =
        removeCommaAndRemoveCurrency(item["annualFuelCostYear5"] || item["AnnualFuelCostYear5"]) ||
        removeCommaAndRemoveCurrency(item["anticipatedFuelCostYear5"] || item["AnticipatedFuelCostYear5"]);

      sumCycleYear1 += y1;
      sumCycleYear2 += y2;
      sumCycleYear3 += y3;
      sumCycleYear4 += y4;
      sumCycleYear5 += y5;
    });

    const latestFuelCosts = sumFuelCosts(latestFuelRows);
    const calculatedAvgMpg =
      sumOrigMpg > 0 ? sumOrigMpg / latestFuelRows.length : (currentYearTotalCost || (anticipatedMpgValue / currentFleetSize) || 0);
    const calculatedAvgYear1Mpg =
      sumCyclingMpg > 0 ? sumCyclingMpg / latestFuelRows.length : (cycleFuelYearCost || 0);
    const calculatedAvgGallon =
      sumAvgGallon > 0 ? sumAvgGallon / latestFuelRows.length : (averageFuelGallon || 0);
    const calculatedTotalFuelSpend =
      sumAnnualCurrent > 0 ? sumAnnualCurrent : (totalFuelSpend || 0);
    const calculatedAnnualSpendVehicle = calculatedTotalFuelSpend / computedFuelSize;
    const calculatedMonthlySpendVehicle = calculatedAnnualSpendVehicle / 12;
    const calculatedFuelSpendY1 =
      sumForecasted > 0
        ? sumForecasted / computedFuelSize
        : (foreCastedValue / currentFleetSize) || (sumCycleYear1 / computedFuelSize) || 0;

    let vehicleSpend = currentTotalAnnualizedSpend / currentFleetSize;
    let costPerMiles =
      currentTotalAnnualizedSpend / averageCostPerMilesMaintanance;
    let avgMpgValue = calculatedAvgMpg;
    let year1Monthly = oneYearTotalCostValue / currentFleetSize / 12;
    let monthlyLeaseCost1 = monthlyLeaseCost / currentFleetSize;
    let foreCastedValue1 = calculatedFuelSpendY1;
    let perCostAvg = vehicleSpend / fuelAverageMileageCache;
    let fleet = {
      currentFleetSize: currentFleetSize,
      avgVehicleYear: Math.floor(avgYear || 0),
      avgNewVehiclePrice: averageNewVehicleCost,
      currentMileage: currentTotalMileage,
      currentCycle: oldVehicleYear,
      annualMiles: fuelAverageMileageCache,
      companyId: companyId,
      dealerId: activeDealerId,
    };
    let maintainanceCost = {
      totalAnnualized: currentTotalAnnualizedSpend,
      vehicleSpend: vehicleSpend,
      vehicleSpendMonth: vehicleSpend / 12,
      costPerMile: perCostAvg,
      companyId: companyId,
      dealerId: activeDealerId,
    };
    let fuelCost = {
      avgMpg: calculatedAvgMpg,
      avgAnnualMiles: fuelAverageMileageCache,
      numberOfVehicle: latestFuelRows.length || currentFleetSize,
      costPerGallon: calculatedAvgGallon,
      totalFuelSpend: calculatedTotalFuelSpend,
      annualSpendVehicle: calculatedAnnualSpendVehicle,
      monthlySpendVehicle: calculatedMonthlySpendVehicle,
      companyId: companyId,
      dealerId: activeDealerId,
    };
    let cyclingComparision = {
      proposedCycle: proposedCycleYear,
      monthlyLeaseCost: monthlyLeaseCost1,
      avgYear1Mpg: calculatedAvgYear1Mpg,
      fuelSpendY1: calculatedFuelSpendY1,
      monthlyMaintananceYear1: year1Monthly,
      avgYear1CostPerMiles: oneYearMaintenanceTotalMiles,
      companyId: companyId,
      dealerId: activeDealerId,
    };
    rowData?.map((items) => {
      items["companyId"] = companyId;
    });

    let fuelValues = [
      calculatedTotalFuelSpend || totalFuelSpend,
      sumCycleYear1 || latestFuelCosts.fuelYear1 || cycleFuelYearCost || 0,
      sumCycleYear2 || latestFuelCosts.fuelYear2 || cycleFuelYearCost2 || 0,
      sumCycleYear3 || latestFuelCosts.fuelYear3 || cycleFuelYearCost3 || 0,
      sumCycleYear4 || latestFuelCosts.fuelYear4 || cycleFuelYearCost4 || 0,
      sumCycleYear5 || latestFuelCosts.fuelYear5 || cycleFuelYearCost5 || 0,
    ];

    let fleetMix = [...rowData].map((fleetRow, index) => {
      const fuel = fuelValues[index] || 0;
      const cashOutlay = Number(removeCurrency(fleetRow.cashOutlay)) || 0;
      const currentPayment = Number(removeCurrency(fleetRow.currentPayment)) || 0;
      const cyclingPayment = Number(removeCurrency(fleetRow.cyclingPayment)) || 0;
      const maintenance = Number(removeCurrency(fleetRow.maintenance)) || 0;
      const vehicleEquity = Number(removeCurrency(fleetRow.vehicleEquity)) || 0;
      const fleetSpeed = cashOutlay + currentPayment + cyclingPayment + maintenance + fuel;
      return {
        ...fleetRow,
        cashOutlay: removeCurrency(fleetRow.cashOutlay),
        currentPayment: removeCurrency(fleetRow.currentPayment),
        cyclingPayment: removeCurrency(fleetRow.cyclingPayment),
        vehicleEquity: removeCurrency(fleetRow.vehicleEquity),
        maintenance: removeCurrency(fleetRow.maintenance),
        fuel: fuel,
        fleetSpeed: fleetSpeed,
      };
    });

    const baseFleetSpeed = fleetMix[0]?.fleetSpeed || 0;
    fleetMix.forEach((fleetRow, index) => {
      fleetRow.savings =
        index === 0
          ? 0
          : parseFloat((baseFleetSpeed - fleetRow.fleetSpeed + (Number(fleetRow.vehicleEquity) || 0)).toFixed(2));
    });

    if (companyNameHeader) {
      let resultData = JSON.stringify({
        fleet: fleet,
        maintainanceCost: maintainanceCost,
        fuelCost: fuelCost,
        cyclingComparision: cyclingComparision,
        fleetMix: fleetMix,
      });
      let payload = {
        reportData: resultData,
        companyId: companyId,
        createdBy: Number(localStorage.getItem("cashflow_admin_user_id")),
        reportName: `${localStorage.getItem("name")}_${companyNameHeader?.companyName}_${moment().format("MM-DD-YYYY")}`,
        createdAt: moment().format(),
      };
      await addAnalysisResultApi(payload);
      if (columnChange) {
        setNextButton("/suggested-year-plan-cost-comparison-analysis");
        setPopupBlock(true);
      } else {
        setSelectedItemIndex(2);
        setSelectedNav(sidebarMenu.analysisResult);
        navigation("/suggested-year-plan-cost-comparison-analysis");
      }
    } else {
      showToast("Please select company name!");
    }
  };
  const handleBack = () => {
    if (columnChange) {
      setPopupBlock(true);
      setPrevButton("/fuel-economy-comparison");
    } else {
      setSelectedNav(sidebarMenu.fuel);
      navigation("/fuel-economy-comparison");
    }
  };

  useEffect(() => {
    if (fleetList?.length > 0) {
      const values = uniqueNullValues(fleetList);
      if (values === "") {
        setRequireFields([]);
      } else {
        values?.map((items) => {
          items += ", ";
        });
        setRequireFields(values);
      }
    }
  }, [fleetList, newVehicle]);

  const handleMovableColumn = async () => {
    const cols = gridRef.current?.api?.getAllGridColumns();
    const colNamesIndex = cols?.map((items, index) => items?.colDef);
    setMovableColumnData(colNamesIndex);
    if (movableColumn?.length > 0) {
      await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fundingNewVehicle,
        ColumnName: JSON.stringify(colNamesIndex),
        id: movableColumn[0]?.id,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
    } else {
      await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fundingNewVehicle,
        ColumnName: JSON.stringify(colNamesIndex),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
    }
    setColumnChange(false);
  };
  const handleColumnChange = (event) => {
    if (event?.column) {
      const cols = gridRef.current?.api?.getAllGridColumns();
      const colNamesIndex = cols?.map((items, index) => items?.colDef);
      setMovableColumnData(colNamesIndex);
      setColumnChange(true);
    }
  };
  const onSortedColumnChange = () =>
    updateGridSortState(gridRef, setSortedColumn, setColumnFinal);
  const onSortedColumnChangeAlready = async () => {
    if (sortableColumnData?.length) {
      setOpenSortingPopup(true);
      return;
    }
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      PageNameConstant.fundingNewVehicle
    );
  };
  useEffect(() => {
    if (fundingPagination && gridRef?.current?.api) {
      gridRef?.current?.api?.paginationGoToPage(fundingPagination);
    }
  }, [fundingPagination, rowDataFinal]);
  return (
    <Box className={classes.mainContent}>
      <CustomTabPanel value={0} index={0}>
        <Box className={classes.gridContantFleetList}>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box className={classes.headerNameText}>Recommended Acquisition Strategy</Box>
            <Box className={classes.sortingFieldText}>
              {columnSortingMessage(sortableColumnData)}
            </Box>
          </Stack>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box className={classes.headerNameText}></Box>
            <Box className={classes.addEditGrid}>
              {!getActiveSortRecord(sortableColumnData) ? (
                <Button
                  variant="contained"
                  className={classes.replacementButtonAction}
                  onClick={onSortedColumnChangeAlready}
                  startIcon={<SortIcon style={{ fontSize: 15 }} />}
                >
                  <span style={{ fontSize: 12 }}>Save Sort</span>
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.replacementButtonAction}
                  onClick={onSortedColumnChangeAlready}
                  startIcon={<SortIcon style={{ fontSize: 15 }} />}
                >
                  <span style={{ fontSize: 12 }}>Save Sort</span>
                </Button>
              )}
              <Button
                variant="contained"
                className={classes.replacementButtonAction}
                onClick={handleMovableColumn}
                startIcon={<ViewWeekIcon style={{ fontSize: 15 }} />}
              >
                <span style={{ fontSize: 12 }}>Save Columns</span>
              </Button>
              <Button
                variant="outlined"
                className={classes.replacementButtonSecondary}
                onClick={handleBack}
              >
                <span style={{ fontSize: 12 }}>Back</span>
              </Button>
              {newVehicle &&
                newVehicle?.length > 0 &&
                requireFields &&
                requireFields?.length === 0 &&
                !loadingApis &&
                requireNewvehicleFields &&
                requireNewvehicleFields?.length === 0 && (
                  <Button
                    variant="contained"
                    className={classes.replacementButtonPrimary}
                    onClick={handleNext}
                    endIcon={<ArrowForwardIcon style={{ fontSize: 15 }} />}
                  >
                    <span style={{ fontSize: 12 }}>Generate Report</span>
                  </Button>
                )}
              <Button
                variant="outlined"
                className={classes.replacementButtonSecondary}
                onClick={handleClick}
                disabled={selectedRows.length === 0}
              >
                <Settings
                  style={{ fontSize: 16, marginBottom: 2, marginRight: 3 }}
                />
                <span style={{ fontSize: 12 }}>Action</span>
              </Button>
              <Button
                variant="outlined"
                className={classes.fleetListNewButton}
                onClick={handleAddButton}
              >
                NEW
              </Button>
              <SearchBar onSearch={onSearch} />
            </Box>
            <>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleOnClose}
              >
                <MenuItem
                  onClick={() =>
                    handleActionSelect("setNewVehicleYear", year, "year")
                  }
                >
                  Set New Vehicle Year
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleActionSelect("setNewVehicleMake", make, "name")
                  }
                >
                  Set New Vehicle Make
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleActionSelect("setNewVehicleModel", modelData, "model")
                  }
                >
                  Set New Vehicle Model
                </MenuItem>
                <MenuItem
                  onClick={() => handleActionSelect("setNewVehicleMPG")}
                >
                  Set New Vehicle MPG
                </MenuItem>
                {/* <MenuItem
                  onClick={() =>
                    handleActionSelect("setNewFuel", fuelList, "name")
                  }
                >
                  Set New Fuel
                </MenuItem> */}
                <MenuItem
                  onClick={() => handleActionSelect("setPaymentAmount")}
                >
                  Set Payment Amount
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleActionSelect(
                      "setFundingType",
                      fundList,
                      "fundingType"
                    )
                  }
                >
                  Set Funding Type
                </MenuItem>

                <MenuItem
                  onClick={() => handleActionSelect("setNewVehicleCost")}
                >
                  Set New Vehicle Cost
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleActionSelect("setNewEstimatedResaleValue")
                  }
                >
                  Set New Estimated Resale Value
                </MenuItem>
                <MenuItem onClick={() => handleActionSelect("setResidual")}>
                  Set Residual %
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleActionSelect(
                      "replaceExistingVehicle",
                      selectedRows,
                      "newVehicle"
                    )
                  }
                >
                  Replace With Existing Vehicle Make/Model
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleActionSelect("setAll", {
                      fuelListArray: fuelList,
                      fundListArray: fundList,
                    })
                  }
                >
                  Set All
                </MenuItem>
              </Menu>
            </>
          </Stack>
          {loading ? (
            <TruckLoader />
          ) : (
            <AgGridReact
              ref={gridRef}
              className="ag-theme-quartz"
              onSelectionChanged={(event) => {
                const selectedNodes = event.api.getSelectedNodes();
                const selectedRows = selectedNodes.map((node) => node.data);
                setFundingPagination(event?.api?.paginationGetCurrentPage());
                setSelectedRows(selectedRows);
              }}
              onRowSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRows = rowDataFinal.filter((row) =>
                  selectedIDs.has(row.id)
                );
                setSelectedRows(selectedRows);
              }}
              rowSelection="multiple"
              suppressRowClickSelection
              pagination={true}
              rowData={rowDataFinal}
              defaultColDef={defaultColDef}
              checkboxSelection
              columnDefs={ensureHeaderTooltip(columnFinal)}
              onCellClicked={onCellClicked}
              onColumnMoved={handleColumnChange}
              onSortChanged={onSortedColumnChange}
            />
          )}
        </Box>
      </CustomTabPanel>
      <AddActionDialogNewVehicle
        modalContent={modalContent}
        closeModal={closeModal}
        selectedRows={selectedRows}
        dropdownValue={dropdownValue}
        keyValue={keyValue}
        companyId={companyId}
        dealerId={dealerNameHeader?.id}
        setSelectedRows={setSelectedRows}
      />
      {deleteOpen && (
        <DeleteDialog
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          deleteApi={() => handleDelete()}
        />
      )}
      {replaceVehicleOpen && (
        <ReplaceExistingVehicle
          open={replaceVehicleOpen}
          selectedRowData={selectedRows}
          companyId={companyId}
          dealerId={dealerNameHeader?.id}
          setOpen={() => setReplaceVehicleOpen(false)}
          fleetList={fleetList}
          setSelectedRows={setSelectedRows}
        />
      )}
      {popupBlock && (
        <PopupBlock
          open={popupBlock}
          setOpen={() => setPopupBlock(false)}
          navigationRouteNext={nextButton}
          navigationRoutePrev={prevButton}
          selectedNavStyle={
            nextButton ? sidebarMenu.analysisResult : sidebarMenu.fuel
          }
          columnChangeData={movableColumnData}
          pageName={PageNameConstant.fundingNewVehicle}
        />
      )}
      {openSortingPopup && (
        <SortingTextPopup
          open={openSortingPopup}
          setOpen={setOpenSortingPopup}
          gridRef={gridRef}
          setSortedColumn={setSortedColumn}
          setColumnFinal={setColumnFinal}
          columnFinal={columnFinal}
          sortableColumnData={sortableColumnData}
          createSortableColumn={createSortableColumn}
          updateViewSortableColumn={updateViewSortableColumn}
          pageName={PageNameConstant.fundingNewVehicle}
        />
      )}
    </Box>
  );
};
